import { FC } from 'react'

import {
  Text,
  GreyGrey80,
  Primary13Regular,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const ModalCancelMandate: FC<{
  mandateId: string
  onClose: () => void
}> = ({ mandateId, onClose }) => {
  const { displayNotification } = useNotifications()

  return (
    <SimpleModal
      variant="dialog"
      isOpen
      onClose={onClose}
      width="436px"
      title="Cancel mandate"
      data-testid="gocardless.mandates.cancelModal"
      isDestructive
      onSubmit={async () => {
        const { error } =
          await dashboardv99990101Client.postCancelGoCardlessCollectionsMandate(
            {
              mandateId
            }
          )

        if (error) {
          // TODO: use `mapApiResponseToFieldValidationErrors` for a more specific error message.
          // The endpoint current returns `text/html` so can't be parsed.
          displayNotification('Unable to cancel mandate', {
            type: 'error'
          })
          return false
        }

        displayNotification('Mandate cancelled', { type: 'success' })
        return true
      }}
      submitButtonText="Cancel mandate"
      submittingButtonText="Cancelling..."
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        Are you sure you want to cancel this mandate? This action cannot be
        undone.
      </Text>
    </SimpleModal>
  )
}
